import React from 'react';
import PropTypes from 'prop-types';
import { GATrackingID } from '/constants';

const Event = ({ on, selector, category, action, label, value }) => {
    const eventFields = {
        eventCategory: category,
        eventAction: action
    };
    if (typeof label !== 'undefined') {
        eventFields.eventLabel = label;
    }
    if (typeof value !== 'undefined') {
        eventFields.eventValue = value;
    }
    const trackEvent = {
        on: on,
        request: 'event',
        vars: eventFields
    };
    if (selector) {
        trackEvent.selector = selector;
    }

    return (
        <amp-analytics type="googleanalytics">
            <script
                type="application/json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        vars: {
                            account: GATrackingID
                        },
                        triggers: {
                            trackEvent: trackEvent
                        }
                    })
                }}
            />
        </amp-analytics>
    );
};

Event.propTypes = {
    on: PropTypes.string.isRequired,
    selector: PropTypes.string,
    category: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.number
};

Event.defaultProps = {
    on: 'click'
};

/**
 * @component
 */
export default Event;
